<div  class="container mt-5">
  
    <div class="row" >
        <!-- Shopping Cart Items -->
     
        <div  class="col-lg-8">
            <h3 *ngIf="cartExist">Hey ! Your Favourite Picks..</h3>
             <h3 *ngIf="!cartExist && Ordered">Hey ! Your Cart is empty..</h3>

            <!-- Cart Item 1 -->
            <div  class="cart-item d-flex justify-content-between" *ngFor="let product of customerCart"> 
                <div *ngIf="!Ordered" class="d-flex">
                    <img src={{product.productImage}} alt="Product" class="product-img me-3">
                    <div>
                        <h5>{{product.productName}}</h5>
                        <p style="font-weight: 600;">Size: {{product.size}}</p>
                        <input type="number" class="form-control w-25" value={{product.quantity}}>
                    </div>
                </div>
                <div *ngIf="!Ordered" class="d-flex flex-column justify-content-between">
                    <span>{{product.discountedPrice | number:'1.2-2' }}</span>
                   <div class="button-container">
                        <button *ngIf="customerLoggedIn && product.cartStatus !== 'Ordered'" class="btn btn-sm removeButton" (click)="AddToOrder(product);">Order</button>
                          <button *ngIf="product.cartStatus !== 'Ordered'" class="btn btn-sm removeButton" (click)=" DeleteFromCartApiCall(product)">Remove</button>
                    </div>
                </div>
            </div>

            <!-- <button class="btn btn-sm removeButton" ></button>
                    <button class="btn btn-sm removeButton" (click)=" DeleteFromCartApiCall(product)">Remove</button> -->
            <!-- Cart Item 2 -->
            <!-- <div class="cart-item d-flex justify-content-between">
                <div class="d-flex">
                    <img src="https://via.placeholder.com/100" alt="Product" class="product-img me-3">
                    <div>
                        <h5>Product Name 2</h5>
                        <p class="text-muted">Another product description.</p>
                        <input type="number" class="form-control w-25" value="2">
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-between">
                    <span>$19.99</span>
                    <button class="btn btn-sm removeButton">Remove</button>
                </div>
            </div> -->

        </div>

        <!-- Cart Summary -->
        <div class="col-lg-4 cartSummary">
            <div class="cart-summary">
                <h4>Cart Summary</h4>
                <ul class="list-unstyled">
                    <li class="d-flex justify-content-between">
                        <span>Subtotal:</span>

                        <span>Rs.{{totAmt}}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Shipping:</span>
                        <span>Rs.50.00</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span class="total-price">Total:</span>
                        <span class="total-price">Rs.{{totAmt + 50}}</span>
                    </li>
                </ul>
                <button (click)="proceedToCheckout()" class="btn btn-checkout w-100">Proceed to Checkout</button>
              
            </div>
        </div>
    </div>
 
</div>

